const LANGS = {
    EN: "en",
    DK: "dk",
    NO: "no",
    SE: "se",
    FI: "fi",
    IS: "is",
    DE: "de",
    FR: "fr",
    ES: "es",
    PT: "pt",
    NL: "nl",
    IT: "it",
    RO: "ro",
    CZ: "cz",
    HR: "hr",
    HU: "hu",
    SK: "sk",
  };
  
  const translations = {
    [LANGS.EN]: {
      filters: {
        location: {
          label: "Location",
          allOption: "All Locations",
        },
        department: {
          label: "Department",
          allOption: "All Departments",
        },
        category: {
          label: "Category",
          allOption: "All Categories",
        },
        job_type: {
          label: "Job Type",
          allOption: "All Job Types",
        },
        workplace_type: {
          label: "Workplace Type",
          allOption: "All Workplace Types",
        },
      },
      jobs: {
        singular: "See 1 available position",
        plural: "See {count} available positions",
      },
      search: {
        placeholder: "Search jobs by title...",
      },
    },
    [LANGS.DK]: {
      filters: {
        location: {
          label: "Lokation",
          allOption: "Alle lokationer",
        },
        department: {
          label: "Afdeling",
          allOption: "Alle afdelinger",
        },
        category: {
          label: "Kategori",
          allOption: "Alle kategorier",
        },
        job_type: {
          label: "Jobtype",
          allOption: "Alle jobtyper",
        },
        workplace_type: {
          label: "Arbejdsstedstype",
          allOption: "Alle arbejdsstedstyper",
        },
      },
      jobs: {
        singular: "Se 1 ledig stilling",
        plural: "Se {count} ledige stillinger",
      },
      search: {
        placeholder: "Søg efter jobtitel",
      },
    },
    [LANGS.NO]: {
      filters: {
        location: {
          label: "Sted",
          allOption: "Alle steder",
        },
        department: {
          label: "Avdeling",
          allOption: "Alle avdelinger",
        },
        category: {
          label: "Kategori",
          allOption: "Alle kategorier",
        },
        job_type: {
          label: "Jobbtype",
          allOption: "Alle jobbtyper",
        },
        workplace_type: {
          label: "Arbeidsstedstype",
          allOption: "Alle arbeidsstedstyper",
        },
      },
      jobs: {
        singular: "Se 1 ledig stilling",
        plural: "Se {count} ledige stillinger",
      },
      search: {
        placeholder: "Søk etter stillingstittel",
      },
    },
    [LANGS.SE]: {
      filters: {
        location: {
          label: "Plats",
          allOption: "Alla platser",
        },
        department: {
          label: "Avdelning",
          allOption: "Alla avdelningar",
        },
        category: {
          label: "Kategori",
          allOption: "Alla kategorier",
        },
        job_type: {
          label: "Jobbtyp",
          allOption: "Alla jobbtyper",
        },
        workplace_type: {
          label: "Arbetsplatstyp",
          allOption: "Alla arbetsplatstyper",
        },
      },
      jobs: {
        singular: "Se 1 ledig tjänst",
        plural: "Se {count} lediga tjänster",
      },
      search: {
        placeholder: "Sök jobb efter titel",
      },
    },
    [LANGS.FI]: {
      filters: {
        location: {
          label: "Sijainti",
          allOption: "Kaikki sijainnit",
        },
        department: {
          label: "Dept",
          allOption: "All departments",
        },
        category: {
          label: "Category",
          allOption: "All categories",
        },
        job_type: {
          label: "Työn tyyppi",
          allOption: "Kaikki työtyypit",
        },
        workplace_type: {
          label: "Työpaikan tyyppi",
          allOption: "Kaikki työpaikkatyypit",
        },
      },
      jobs: {
        singular: "Katso 1 avoin työpaikka",
        plural: "Katso {count} avointa työpaikkaa",
      },
      search: {
        placeholder: "Hae työpaikkoja nimellä",
      },
    },
    [LANGS.IS]: {
      filters: {
        location: {
          label: "Staðsetning",
          allOption: "Allar staðsetningar",
        },
        department: {
          label: "Deild",
          allOption: "Allar deildir",
        },
        category: {
          label: "Flokkur",
          allOption: "Allir flokkar",
        },
        job_type: {
          label: "Starfstegund",
          allOption: "Allar starfstegundir",
        },
        workplace_type: {
          label: "Vinnustaðategund",
          allOption: "Allar vinnustaðategundir",
        },
      },
      jobs: {
        singular: "Sjá 1 laust starf",
        plural: "Sjá {count} laus störf",
      },
      search: {
        placeholder: "Leita að störfum eftir titli",
      },
    },
    [LANGS.DE]: {
      filters: {
        location: {
          label: "Standort",
          allOption: "Alle Standorte",
        },
        department: {
          label: "Abteilung",
          allOption: "Alle Abteilungen",
        },
        category: {
          label: "Kategorie",
          allOption: "Alle Kategorien",
        },
        job_type: {
          label: "Stellenart",
          allOption: "Alle Stellenarten",
        },
        workplace_type: {
          label: "Arbeitsplatztyp",
          allOption: "Alle Arbeitsplatztypen",
        },
      },
      jobs: {
        singular: "1 verfügbare Stelle anzeigen",
        plural: "{count} verfügbare Stellen anzeigen",
      },
      search: {
        placeholder: "Jobs nach Titel suchen",
      },
    },
    [LANGS.FR]: {
      filters: {
        location: {
          label: "Emplacement",
          allOption: "Tous les emplacements",
        },
        department: {
          label: "Département",
          allOption: "Tous les départements",
        },
        category: {
          label: "Catégorie",
          allOption: "Toutes les catégories",
        },
        job_type: {
          label: "Type d'emploi",
          allOption: "Tous les types d'emploi",
        },
        workplace_type: {
          label: "Type de lieu de travail",
          allOption: "Tous les types de lieu de travail",
        },
      },
      jobs: {
        singular: "Voir 1 poste disponible",
        plural: "Voir {count} postes disponibles",
      },
      search: {
        placeholder: "Rechercher des postes par intitulé",
      },
    },
    [LANGS.ES]: {
      filters: {
        location: {
          label: "Ubicación",
          allOption: "Todas las ubicaciones",
        },
        department: {
          label: "Departamento",
          allOption: "Todos los departamentos",
        },
        category: {
          label: "Categoría",
          allOption: "Todas las categorías",
        },
        job_type: {
          label: "Tipo de empleo",
          allOption: "Todos los tipos de empleo",
        },
        workplace_type: {
          label: "Tipo de lugar de trabajo",
          allOption: "Todos los tipos de lugar de trabajo",
        },
      },
      jobs: {
        singular: "Ver 1 puesto disponible",
        plural: "Ver {count} puestos disponibles",
      },
      search: {
        placeholder: "Buscar puestos por título",
      },
    },
    [LANGS.PT]: {
      filters: {
        location: {
          label: "Localização",
          allOption: "Todas as localizações",
        },
        department: {
          label: "Departamento",
          allOption: "Todos os departamentos",
        },
        category: {
          label: "Categoria",
          allOption: "Todas as categorias",
        },
        job_type: {
          label: "Tipo de emprego",
          allOption: "Todos os tipos de emprego",
        },
        workplace_type: {
          label: "Tipo de local de trabalho",
          allOption: "Todos os tipos de local de trabalho",
        },
      },
      jobs: {
        singular: "Ver 1 vaga disponível",
        plural: "Ver {count} vagas disponíveis",
      },
      search: {
        placeholder: "Pesquisar vagas por título",
      },
    },
    [LANGS.NL]: {
      filters: {
        location: {
          label: "Locatie",
          allOption: "Alle locaties",
        },
        department: {
          label: "Afdeling",
          allOption: "Alle afdelingen",
        },
        category: {
          label: "Categorie",
          allOption: "Alle categorieën",
        },
        job_type: {
          label: "Functie type",
          allOption: "Alle functie types",
        },
        workplace_type: {
          label: "Type werkplek",
          allOption: "Alle werkplektypen",
        },
      },
      jobs: {
        singular: "Bekijk 1 beschikbare functie",
        plural: "Bekijk {count} beschikbare functies",
      },
      search: {
        placeholder: "Zoek vacatures op titel",
      },
    },
    [LANGS.IT]: {
      filters: {
        location: {
          label: "Posizione",
          allOption: "Tutte le posizioni",
        },
        department: {
          label: "Dipartimento",
          allOption: "Tutti i dipartimenti",
        },
        category: {
          label: "Categoria",
          allOption: "Tutte le categorie",
        },
        job_type: {
          label: "Tipo di lavoro",
          allOption: "Tutti i tipi di lavoro",
        },
        workplace_type: {
          label: "Tipo di luogo di lavoro",
          allOption: "Tutti i tipi di luogo di lavoro",
        },
      },
      jobs: {
        singular: "Vedi 1 posizione disponibile",
        plural: "Vedi {count} posizioni disponibili",
      },
      search: {
        placeholder: "Cerca posizioni per titolo",
      },
    },
    [LANGS.RO]: {
      filters: {
        location: {
          label: "Locație",
          allOption: "Toate locațiile",
        },
        department: {
          label: "Departament",
          allOption: "Toate departamentele",
        },
        category: {
          label: "Categorie",
          allOption: "Toate categoriile",
        },
        job_type: {
          label: "Tip de job",
          allOption: "Toate tipurile de job",
        },
        workplace_type: {
          label: "Tip loc de muncă",
          allOption: "Toate tipurile de loc de muncă",
        },
      },
      jobs: {
        singular: "Vezi 1 post disponibil",
        plural: "Vezi {count} posturi disponibile",
      },
      search: {
        placeholder: "Caută posturi după titlu",
      },
    },
    [LANGS.CZ]: {
      filters: {
        location: {
          label: "Lokalita",
          allOption: "Všechny lokality",
        },
        department: {
          label: "Oddělení",
          allOption: "Všechna oddělení",
        },
        category: {
          label: "Kategorie",
          allOption: "Všechny kategorie",
        },
        job_type: {
          label: "Typ práce",
          allOption: "Všechny typy práce",
        },
        workplace_type: {
          label: "Typ pracoviště",
          allOption: "Všechny typy pracovišť",
        },
      },
      jobs: {
        singular: "Zobrazit 1 volnou pozici",
        plural: "Zobrazit {count} volných pozic",
      },
      search: {
        placeholder: "Hledat pozice podle názvu",
      },
    },
    [LANGS.HR]: {
      filters: {
        location: {
          label: "Lokacija",
          allOption: "Sve lokacije",
        },
        department: {
          label: "Odjel",
          allOption: "Svi odjeli",
        },
        category: {
          label: "Kategorija",
          allOption: "Sve kategorije",
        },
        job_type: {
          label: "Vrsta posla",
          allOption: "Sve vrste posla",
        },
        workplace_type: {
          label: "Vrsta radnog mjesta",
          allOption: "Sve vrste radnog mjesta",
        },
      },
      jobs: {
        singular: "Prikaži 1 otvorenu poziciju",
        plural: "Prikaži {count} otvorenih pozicija",
      },
      search: {
        placeholder: "Pretraži pozicije prema nazivu",
      },
    },
    [LANGS.HU]: {
      filters: {
        location: {
          label: "Helyszín",
          allOption: "Összes helyszín",
        },
        department: {
          label: "Osztály",
          allOption: "Összes osztály",
        },
        category: {
          label: "Kategória",
          allOption: "Összes kategória",
        },
        job_type: {
          label: "Munka típusa",
          allOption: "Összes munka típus",
        },
        workplace_type: {
          label: "Munkahely típusa",
          allOption: "Összes munkahelytípus",
        },
      },
      jobs: {
        singular: "1 elérhető pozíció megtekintése",
        plural: "{count} elérhető pozíció megtekintése",
      },
      search: {
        placeholder: "Állások keresése cím szerint",
      },
    },
    [LANGS.SK]: {
      filters: {
        location: {
          label: "Lokalita",
          allOption: "Všetky lokality",
        },
        department: {
          label: "Oddelenie",
          allOption: "Všetky oddelenia",
        },
        category: {
          label: "Kategória",
          allOption: "Všetky kategórie",
        },
        job_type: {
          label: "Typ práce",
          allOption: "Všetky typy práce",
        },
        workplace_type: {
          label: "Typ pracoviska",
          allOption: "Všetky typy pracovísk",
        },
      },
      jobs: {
        singular: "Zobraziť 1 dostupnú pozíciu",
        plural: "Zobraziť {count} dostupných pozícií",
      },
      search: {
        placeholder: "Hľadať pozície podľa názvu",
      },
    },
  };

  export { translations, LANGS };